import(/* webpackMode: "eager", webpackExports: ["HeaderSearchBar"] */ "/app/src/app/(frontend)/products/HeaderSearchBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewArrivalsSection"] */ "/app/src/app/(frontend)/products/NewArrivalsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductsCarouselClient"] */ "/app/src/app/(frontend)/products/ProductsCarouselClient.tsx");
